import React from 'react';

interface Row {
  metric: string;
  value: string | null;
  read: string | null;
  bold?: boolean;
}

interface Props {
  rows: Row[];
  portfolioNarrative?: string;
}

const ExposureTable: React.FC<Props> = ({ rows, portfolioNarrative }) => {
  if (!rows || rows.length === 0) return null;
  return (
    <section className="exposure-table-section">
      <h3>Exposure in risk terms</h3>
      <div className="exposure-table-wrap">
        <table className="exposure-table">
          <thead>
            <tr>
              <th>Metric</th>
              <th className="num">Value</th>
              <th>Read</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i}>
                <td className="metric">{r.metric}</td>
                <td className={`num ${r.bold ? 'bold' : ''}`}>{r.value ?? '—'}</td>
                <td className="read">{r.read ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {portfolioNarrative && (
        <p className="exposure-narrative">{portfolioNarrative}</p>
      )}
    </section>
  );
};

export default ExposureTable;
